import * as XLSX from 'xlsx';

export function makeExcel_keywordRankingTable(dailyList: any[]) {
  if (!dailyList || dailyList.length === 0) return;

  // 날짜(컬럼) 추출 (최신순 정렬)
  const dateList = dailyList.map((d) => d.MonitoringDate?.slice(0, 10)).filter(Boolean);

  // 키워드(행) 추출 (첫 번째 날짜 기준)
  const keywordList = dailyList[0]?.RelatedKeywordsRanking?.map((k: any) => k.Keyword) || [];

  // 테이블 데이터 생성 (엑셀용 2차원 배열)
  const tableData: any[][] = [];
  // 첫 행: 헤더
  tableData.push(['키워드', ...dateList]);

  // 각 키워드별로 행 생성
  keywordList.forEach((keyword: string) => {
    const row = [keyword];
    dailyList.forEach((day: any) => {
      const kw = day.RelatedKeywordsRanking.find((k: any) => k.Keyword === keyword);
      let cell = '-';
      if (kw) {
        if (kw.Rank > 0) {
          cell = `${kw.Rank}위`;
        } else {
          cell = '1000위 밖';
        }
        // 상태 표시 추가 (▲, ▼, -)
        if (kw.RankingChangedStatus === 'up') {
          cell += ` ▲${Math.abs(kw.RankingChangedRange)}`;
        } else if (kw.RankingChangedStatus === 'down') {
          cell += ` ▼${Math.abs(kw.RankingChangedRange)}`;
        }
      }
      row.push(cell);
    });
    tableData.push(row);
  });

  // 엑셀 워크시트 및 파일 생성
  const ws = XLSX.utils.aoa_to_sheet(tableData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '키워드랭킹');
  XLSX.writeFile(wb, '키워드랭킹_테이블.xlsx');
}
